import { keyframes } from "@emotion/css";
import { Brightness } from "Shared/themes/Brightness";
import { ShowForegroundOnTimer } from "Shared/themes/ShowForegroundOnTimer";

export interface IAnimation {
	type: 'enable'|'enableOnce';
	options?: any;
	css?: any;
};

export interface IStylesRule {
	location: string[],
	css?: any,
	ignorePageMargins?: boolean,
	parallax?: boolean,
	border?;
	padding?;

	animations?: IAnimation[];
};

type Styles = {
	ui: XXX, //COMPONENT

	rules: (params:any) => {
		[name:string]: IStylesRule[]
	}
};


export function standardStyles(sizes,text): Styles
{
//TODO Probably better to have key/label pairs...
//XXX could have children to allow locations to specify sublocations. Probably better to implement eventually.
//XXX maybe support as 'posters:events' & 'posters:specials'
//XXX PROBABLY better done on a site basis... for the most part  TODO


	return {
/*				
		'No image margins on mobile': {
			rules: () => [{
				location: ['**','image'],
				noMarginsOnMobile: true
			}]
		},
*/				

		'Ignore page margins': {
			rules: () => [{
				location: ['*'],
				ignorePageMargins: true
			}]
		},
		'Parallax': {
			rules: () => [{
				location: ['*'],
				parallax: true
			}]
		},
		//TODO separate out standard styles so we dont have to explicity include them
		'Standard page headings': {
			rules: () => [{
				location: ['**','*:Page heading','**','text:title'],
				css: text.pageTitle
			}]
		},

		'Brightness': {
			ui: Brightness,

			rules: params => [{
				location: ['**','image'],

				css: { 
					filter: `brightness(${params.brightness}%)`
				},
			}]
		},

		'Overlay foreground background': {
			rules: () => [{
				location: ['**','overlay','foreground','*'],
				padding: {sides:'all',all:'2em'},
				css: {
					backgroundColor: 'rgba(0, 0, 0, 0.56)'
				}
			}]
		},
		//XXX modelled off The Townie club page. 
		'Narrow page': {
			rules: () => [{
				location: ['^'],
				css: {
					maxWidth: 820,
					marginLeft: 'auto',
					marginRight: 'auto',
				}
			}]
		},
		//XXX use in The Townie club page description. Should descriptions be left justified by default?
		'Left align': {
			rules: () => [{
				location: ['*'],
				css: {
					textAlign: 'left'
				}
			}]
		},

		'Footer grid': {
			rules: () => [{
				location: ['*'],
				css: {
					justifyItems: 'stretch',
					columnGap: 0,
					rowGap: 0,
					'> :first-child': {
						border: 'solid 2px orange'
					},
					'> :nth-child(2)': {
						border: 'solid 2px red'
					},
					'> :nth-child(3)': {
						border: 'solid 2px green'
					},
					'> :nth-child(4)': {
						border: 'solid 2px purple'
					},
					'> :nth-child(5)': {
						border: 'solid 2px yellow'
					},
					'> :nth-child(6)': {
						border: 'solid 2px orange'
					},
					'> :nth-child(7)': {
						border: 'solid 2px brown'
					},
					'> :last-child(8)': {
						border: 'solid 2px blue'
					},

					[`@media (max-width:900px)`]: {
						gridTemplateColumns: '1fr 1fr 1fr'
					},

					[`@media (max-width:${sizes.flipToOneColumn}px)`]: {
						gridTemplateColumns: '1fr',
						gridTemplateRows: 'repeat(8,500px)'
					},
				}
			}]
		},

		'Fade in': {
			rules: () => [{
				location: ['*'],

				css: {
					transition: 'opacity 1s',
					opacity: 0.1,
				},

				animations: [{
					type: 'enableOnce',
					options: {threshold: 0.3},
					css: {
						opacity: 1.0,
					}
				}]
			}]
		},

		'Show foreground on timer': {
			ui: ShowForegroundOnTimer,
			//XXX cf defaults

			rules: params => [{
				location: ['*'],

				css: { 
					[`@media (min-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							...timedFades(params.groupSize,params.cycleTime,params.startingPosition),

							transition: 'opacity 1s',
							'&:hover': {
								opacity: '1.0 !important',
							}
						}
					},

					[`@media (max-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							transition: 'opacity 1s',
							opacity: 0.1,
						}
					},
				},

				animations: [{
					type: 'enable',
					options: {threshold: 0.8},
					css: {
						[`@media (max-width:${sizes.flipToOneColumn}px)`]: {
							'> :nth-child(2)': {
								opacity: 1.0,
							}
						}
					}
				}]
			}]
		},

		/* Examples:

		'Orange features': {
			rules: () => [{
				location: ['**','*:Featured','**','text'],
				css: {
					border: 'solid 10px orange'
				}
			}]
		},
		'Pink special pages': {
			rules: () => [{
				location: ['^:Special page'],
				css: {
					backgroundColor: 'pink'
				}
			}]
		}
		*/
	};
}

/* startingPosition starts at 1 */
function timedFades(groupSize:number,itemCycleTime/*secs*/:number,startingPosition:number)
{
	const startPos = startingPosition - 1;

	return {
		animation: keyframes`
			0%  { opacity: 0; }  
			${20/groupSize}% { opacity: 1; } 
			${80/groupSize}% { opacity: 1; } 
			${100/groupSize}% { opacity: 0; }  
			100% { opacity: 0; }  
		` + ` ${groupSize * itemCycleTime}s infinite`,
		animationDelay: (itemCycleTime * startPos) + 's',
	};
}

